import {Component, OnInit, Inject, ElementRef} from "@angular/core";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";

import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CommonService,
  AlertService,
  AdminService,
  LeadService,
} from "../../_services/";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: "app-edit-reminder-dialog",
  templateUrl: "./edit-reminder-dialog.component.html",
  styleUrls: ["./edit-reminder-dialog.component.scss"],
})
export class EditReminderDialogComponent implements OnInit {
  editReminderForm: FormGroup;
  submitted: Boolean = false;
  hour12Timer: Boolean = true;
  constructor(
    public dialogRef: MatDialogRef<EditReminderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _common: CommonService,
    private _alert: AlertService,
    private _admin: AdminService,
    private _lead: LeadService,
    private _toastr: ToastrService
  ) {}

  ngOnInit() {
    this.editReminderForm = this.formBuilder.group({
      reminder_id: [null, []],
      body: [null, []],
      date: [null, []],
    });

    this.getReminderDetail(this.data.reminder_id);
  }

  getReminderDetail(reminder_id: String) {
    this._lead.getReminderById(reminder_id).subscribe(
      (res) => {
        const reminderObj: any = res.payload.data();
        this.editReminderForm.patchValue({
          reminder_id: reminderObj.id,
          body: reminderObj.body,
          date: new Date(reminderObj.date),
        });
      },
      (err) => {
        console.error(err, "error reponse from server");
      }
    );
  }

  hideAddReminderDialog() {
    this.dialogRef.close();
  }

  n(num) {
    return num > 9 ? num : "0" + num;
  }

  onFormSubmit() {
    this.submitted = true;
    if (this.editReminderForm.invalid) {
      return;
    }
    let form = this.editReminderForm.value;
    const formObj = {
      body: form.body,
      date:
        this.n(new Date(form.date).getMonth() + 1) +
        "/" +
        this.n(new Date(form.date).getDate()) +
        "/" +
        new Date(form.date).getFullYear(),
    };

    this._common.showLoader(true);

    this._lead
      .editReminder(formObj, form.reminder_id)
      .then((res) => {
        this._common.showLoader(false);
        this.dialogRef.close();
        this._toastr.success(`Reminder added successfully!`, "", {
          timeOut: 4000,
        });
      })
      .catch((error) => {
        this._toastr.error(`Something went wrong!`, "", {timeOut: 4000});
      });
  }
}
